import { datadogRum } from '@datadog/browser-rum';
import { env } from 'src/config/env';
import { getStore } from './storeRegistry';

function getSlimUser(user, groupId) {
  const groupEntry = user.groups.find((g) => g.group.id === groupId);
  const roles = groupEntry.roles
    .map((role) => role.name)
    .filter((name, index, arr) => arr.indexOf(name) === index);
  const networks = user.networks.map((n) => ({ id: n.id, name: n.name }));

  return {
    email: user.email,
    first_name: user.first_name,
    id: user.id,
    impersonation_type: user.impersonation_type || '',
    last_name: user.last_name,
    networks,
    roles,
  };
}

function getSlimGroup(state) {
  const { id, name, state: groupState } = state.user.groups
    .find((g) => g.group.id === state.session.groupId).group;

  return { id, name, state: groupState };
}

export default function trackEvent(eventName, payload = {}) {
  try {
    const state = getStore().getState();
    const trackingUrl = env.TRACKING_URL || state.session.app_support.app.analytics_proxy_url;

    const body = {
      event: { name: eventName, created_at: Math.floor(Date.now() / 1000) },
      payload: { ...payload, source: 'app-client' },
      user: getSlimUser(state.user, state.session.groupId),
      group: getSlimGroup(state),
    };

    fetch(`${trackingUrl}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch (error) {
    datadogRum.addError(new Error(`trackEvent: ${error.message}`), { eventName });
  }
}
